<!--
* UI Name: Trigger Right Layout
* Modify Date: 2023/01/05
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    :rightSticky="true"
    class="cus-bg-dialog"
    style="top:0;right:0;left:auto"
  >
    <template v-slot:title>
      <v-card-title class="headline white--text px-6 mr-5" primary-title>
        <v-btn
          disabled
          class="mb-1 mr-1 proc-button-style proc-trigger drag-drawflow"
          x-small
          height="30"
          width="30"
          color="proc darken-1"
        >
          <icon-svg :size="procIconSize" iconName="proc-trigger" />
        </v-btn>
        <font class="text-xl font-bold leading-snug textcolor5--text">
          Trigger
        </font>
        <v-spacer></v-spacer>
        <v-btn
          class="btn btn-save rounded-xl mr-2"
          :disabled="!$auth.manage"
          v-if="!isHistory"
          @click="save"
          >{{ $t('btn.common.save') }}</v-btn
        >
        <v-btn
          class="btn btn-delete rounded-xl mr-2"
          :disabled="!$auth.manage || !formData.tr_id"
          v-if="!isHistory"
          @click="deleteTrigger"
          >{{ $t('btn.common.delete') }}</v-btn
        >
        <v-btn class="btn btn-close rounded-xl" :disabled="!$auth.manage" @click="closeComDialog">{{
          $t('btn.common.close')
        }}</v-btn>
      </v-card-title>
    </template>
    <v-form ref="form" lazy-validation class="px-6 mt-5" style="height: 807px; overflow: auto">
      <v-row class="mt-0">
        <v-col cols="12" md="12" class="px-3 py-0">
          <div class="d-flex justify-space-between align-center">
            <v-label>
              <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
              Trigger
            </v-label>
            <div class="right-text">
              <v-btn
                style="visibility: hidden;height:22px;"
                :disabled="isHistory"
                class="px-0"
                @click="copyData"
              >
                <icon-svg
                  style="visibility: visible;"
                  width="60"
                  height="22"
                  iconName="comp-copy"
                />
              </v-btn>
              <v-btn
                style="visibility: hidden;height:22px;"
                :disabled="isHistory"
                class="px-0"
                @click="clearData"
              >
                <icon-svg
                  style="visibility: visible;"
                  width="60"
                  height="22"
                  iconName="comp-clear"
                />
              </v-btn>
            </div>
          </div>
          <v-combobox
            v-model="comId"
            :items="triggerList"
            :rules="[validationUtils.required]"
            :disabled="!$auth.manage"
            :readonly="isHistory"
            item-value="tr_id"
            item-text="tr_name"
            autofocus
            solo
            @change="changeComponentData()"
          >
          </v-combobox>
        </v-col>
        <v-col cols="12" md="12" class="px-3 py-0">
          <v-label>
            <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
            {{ $t('lbl.communications.exeInterval') }}
          </v-label>
        </v-col>
        <v-col cols="12" md="4" class="pl-3 pr-2 py-0">
          <v-text-field
            ref="interval"
            v-model="formData.tr_interval"
            type="number"
            :rules="[validationUtils.required_long, validateInterval(formData.intervalType)]"
            solo
            :disabled="!$auth.manage"
            :readonly="isHistory"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8" class="pr-3 pl-2 py-0">
          <v-select
            v-model="formData.tr_interval_tp"
            :items="intervals"
            solo
            :menu-props="{ offsetY: true }"
            :disabled="!$auth.manage"
            :readonly="isHistory"
          ></v-select>
        </v-col>
      </v-row>
    </v-form>
    <discardChange
      ref="confirmDialog"
      detail="Discard Changes?"
      :showCancel="true"
      color="information"
      size="max"
      title="confirmDialog"
      @select-confirm="removeDialog()"
    ></discardChange>
    <dialogWindow
      ref="AlertTriggerSetup"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="$refs.AlertTriggerSetup.dialog = false"
    >
    </dialogWindow>
    <dialogWindow
      ref="RegisteredSuccess"
      size="max"
      :detail="$t('msg.common.success.detail', ['Trigger', 'created'])"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="ModifiedSuccess"
      size="max"
      :detail="$t('msg.common.success.detail', ['Trigger', 'modified'])"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="deleteTrigger"
      title="Delete trigger"
      size="max"
      :detail="$t('lbl.processSetup.delComponent', ['trigger'])"
      color="confirmation"
      :showCancel="true"
      @select-ok="actionDel()"
    >
    </dialogWindow>
  </dialog-drag>
</template>

<script>
import $ from 'jquery';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import discardChange from '@/vue-dlb/components/DiscardChange.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { getEditData } from '@/vue-caas/utils/process';
import { runSave } from '@/vue-caas/views/processnew/component/saveRunner.js';

export default {
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
  },
  components: {
    dialogWindow,
    DialogDrag,
    discardChange,
    IconSvg,
  },
  data() {
    return {
      procIconSize: 16,
      isHistory: false,
      comId: '',
      nodeId: '',
      comTp: 'TRIG',
      formData: {
        tr_id: '',
        tr_name: '',
        tr_interval: '30',
        tr_interval_tp: 'MM',
      },
      intervals: [
        { text: this.$t('msg.communications.seconds'), value: 'SS' },
        { text: this.$t('msg.communications.minutes'), value: 'MM' },
        { text: this.$t('msg.communications.hours'), value: 'HH' },
      ],
      loadFormData: {
        tr_id: '',
        tr_name: '',
        tr_interval: '30',
        tr_interval_tp: 'MM',
      },
      checkDialogInfo: '',
      checkDialogColor: 'warning',
    };
  },
  created() {
    this.initialize();
    EventBus.$on('check-right-layer-change', this.closeComDialog);
  },
  methods: {
    copyData() {
      this.formData.tr_id = '';
      this.formData.tr_name = '';
      this.comId = '';
      EventBus.$emit('change-component-data', '', this.nodeId);
    },
    clearData() {
      this.changeTrigger('');
      this.comId = '';
    },
    changeComponentData() {
      if (this.comId && this.comId.value) {
        this.changeTrigger(this.comId.value);
      } else {
        if (this.formData.tr_id) {
          this.changeTrigger('');
        }
        this.formData.tr_name = this.comId;
      }
      this.validateTriggerName();
    },
    initialize() {
      this.nodeId = this.options.item.data.nodeId;
      this.comTp = this.options.item.data.comTp;
      if (this.options.item.isHistory) this.isHistory = this.options.item.isHistory;
      this.changeTrigger(this.options.item.data.comId);
    },
    changeTrigger(id) {
      if (this.$refs.form) this.$refs.form.resetValidation();
      let index = this.triggerList.findIndex((e) => e.tr_id == id);
      if (index > -1) {
        this.formData = Object.assign({}, this.triggerList[index]);
        this.loadFormData = Object.assign({}, this.triggerList[index]);
        this.comId = Object.assign({}, this.triggerList[index]);
        EventBus.$emit('change-component-data', id, this.nodeId);
      } else {
        this.formData = {
          tr_id: '',
          tr_name: '',
          tr_interval: '30',
          tr_interval_tp: 'MM',
        };
        EventBus.$emit('change-component-data', '', this.nodeId);
      }
    },
    async save() {
      const result = await runSave(this, 'TRIG', { mode: 'form', data: this.formData });
      if (!result.success) {
        console.log(result.message);
      }
    },
    actionDel() {
      let self = this;
      this.$store.dispatch('deleteTriggerComponent', { tr_id: this.formData.tr_id }).then(() => {
        this.$store.dispatch('getTriggerSelectBoxList').then(() => {
          this.$refs.form.resetValidation();
          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;
            if (comp.comTp == 'TRIG') {
              if (comp.formData.tr_id === self.formData.tr_id) {
                comp.resetForm();
              }
            }
          });
          this.comId = '';
          this.changeTrigger('');
        });
      });
    },
    deleteTrigger() {
      this.$refs.deleteTrigger.dialog = true;
    },
    validateTriggerName() {
      this.triggerList.map((e) => {
        if (e.tr_name === this.formData.tr_name && e.tr_id !== this.formData.tr_id) {
          this.formData.tr_name = '';
          this.comId = '';
          this.checkDialogInfo = `Trigger name : ${e.tr_name} have been created !`;
          this.checkDialogColor = 'warning';
          this.$refs.AlertTriggerSetup.dialog = true;
          return;
        }
      });
    },
    validateInterval(item) {
      let interval = this.formData.tr_interval;
      if (interval) {
        switch (item) {
          case 'SS': {
            if (interval < 10 || interval > 59) {
              return this.$t('msg.workflow.validateInterval', [
                '10',
                '59',
                this.$t('msg.workflow.seconds'),
              ]);
            }
            break;
          }
          case 'HH': {
            if (interval < 1 || interval > 24) {
              return this.$t('msg.workflow.validateInterval', [
                '1',
                '24',
                this.$t('msg.workflow.hours'),
              ]);
            }
            break;
          }
          default: {
            if (interval < 1 || interval > 59) {
              return this.$t('msg.workflow.validateInterval', [
                '1',
                '59',
                this.$t('msg.workflow.minutes'),
              ]);
            }
          }
        }
      }
      return true;
    },
    closeComDialog() {
      this.checkDataChange();
    },

    checkDataChange() {
      let editedData = getEditData(this.formData, this.loadFormData);
      if (Object.keys(editedData).length !== 0) {
        this.$refs.confirmDialog.dialog = true;
      } else {
        this.removeDialog();
      }
    },
    removeDialog() {
      this.closeDialog(this.id);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },
  computed: {
    triggerList() {
      return this.$store.getters.triggerSelectBoxList;
    },
  },
};
</script>

<style></style>
